class FavoriteAdventures {
	constructor() {
		this.url = new URL(window.location);
		this.urlIds = this.url.searchParams.get('ids');
		this.favoriteAdventures = JSON.parse(
			localStorage.getItem('favoriteAdventures')
		);
		if (null === this.favoriteAdventures) {
			this.favoriteAdventures = [];
			localStorage.setItem(
				'favoriteAdventures',
				JSON.stringify(this.favoriteAdventures)
			);
		}

		const postIdMatch = document.body.classList.value.match(
			new RegExp('(?<=-id-).*?(?= )')
		);

		if (postIdMatch && postIdMatch[0]) {
			this.postId = postIdMatch[0];
		}
	}
	init() {
		this.getFavorites();
	}
	bindEvents() {
		const buttons = document.querySelectorAll(
			'.component-add-to-favorites--is-favorite'
		);
		const shareButtons = document.querySelectorAll(
			'.block-favorite-adventures__share-button'
		);
		buttons.forEach((el, i) => {
			el.addEventListener('click', () => {
				if (
					this.postId &&
					WP.sharedFavoritesPage &&
					this.postId === WP.sharedFavoritesPage
				) {
					return;
				}

				el.closest('.adventure-card').remove();
				this.removeFromFavorites(el.dataset.adventure);
				// update share IDs
				if (shareButtons.length) {
					shareButtons.forEach((shareButton) => {
						const url = shareButton.href;
						let splitUrl = url.split('=', 2);
						splitUrl = splitUrl[0];
						const newIDs = this.favoriteAdventures.join(',');
						const newUrl = splitUrl + '=' + newIDs;

						shareButton.href = newUrl;
					});
				}
			});
		});
		const event = new Event('pageHeightChange');
		document.dispatchEvent(event);

		if (shareButtons.length) {
			navigator.permissions
				.query({ name: 'clipboard-write' })
				.then((result) => {
					if (
						result.state === 'granted' ||
						result.state === 'prompt'
					) {
						shareButtons.forEach((shareButton) => {
							shareButton.addEventListener('click', (e) => {
								e.preventDefault();
								const button = e.currentTarget;

								navigator.clipboard
									.writeText(button.getAttribute('href'))
									.then(() => {
										button.innerHTML =
											'<i class="icon-link"></i>Copied to Clipboard';
									});
							});
						});
					}
				});
		}
	}
	async getFavorites() {
		let favorites;

		if (
			this.urlIds &&
			this.postId & WP.sharedFavoritesPage &&
			this.postId === WP.sharedFavoritesPage
		) {
			favorites = this.urlIds.split(',');
		} else if (this.favoriteAdventures.length) {
			favorites = this.favoriteAdventures;
		}

		if (favorites && favorites.length) {
			const data = {
				action: 'get_favorite_adventures',
				adventures: favorites,
			};

			if (this.postId) {
				data.postId = this.postId;
			}

			await fetch(WP.ajaxUrl, {
				method: 'POST',
				body: new URLSearchParams(data).toString(),
				headers: {
					'Content-type': 'application/x-www-form-urlencoded',
				},
			})
				.then((response) => response.text())
				.then((html) => {
					this.displayFavorites(html);
					this.bindEvents();
				});
		} else {
			this.displayFavorites(
				'<div class="col-12 text-center"><p>No adventures saved.</p></div>'
			);
		}
	}
	displayFavorites(html) {
		document.getElementById('favorite-adventures').innerHTML = html;
	}
	// TODO: Call this from class AddToFavorites class?
	// TODO: Display message if all Adventures are removed.
	removeFromFavorites(adventure) {
		const index = this.favoriteAdventures.indexOf(adventure.toString());
		this.favoriteAdventures.splice(index, 1);
		localStorage.setItem(
			'favoriteAdventures',
			JSON.stringify(this.favoriteAdventures)
		);
		this.getFavorites();
	}
}

const newFavoriteAdventures = new FavoriteAdventures();

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		newFavoriteAdventures.init();
	},
	loaded() {},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
	pageHeightChange() {},
};
export default controller;
